import { getAppUserLinks } from "global/auth/accessPermissions";
import _ from "lodash";
import { useContext, useMemo } from "react";
import { ParentContext } from "../ParentContext";
import { useAccessPermissions } from "./useAccessPermissions";
import { useAppUserAccess } from "./useAppUserAccess";

export const useNavigationOptions = (props) => {
  const {
    itemData,
    view,
    viewItem,
    viewKey,
  } = props;

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { currentSettings_state } = states ?? {};
  const appUserAccess = useAppUserAccess();

  // get aps_appUserSettings safely
  const { gvviSettings } = currentSettings_state ?? {};
  const { aps_appUserSettings } = gvviSettings ?? {};

  // Hook (top-level) — return value must be part of memo deps
  const pageNavOptions = useAccessPermissions({
    accessRequests: null,
    view,
    viewItem,
    viewKey,
  });

  const result = useMemo(() => {
    const { appUserSessionKey } = appUserAccess ?? {};
    const { appUserCollection, allowLinks, links } = aps_appUserSettings ?? {};

    // Prefer pure return from helper; if getAppUserLinks mutates, this still works
    const appUserLinkItems = [];
    if (itemData && allowLinks && links && appUserSessionKey) {
      getAppUserLinks(appUserLinkItems, appUserCollection, links, itemData, viewKey, viewItem, itemData?.id);
    }

    const allowItemPopup = getAllowPopup(pageNavOptions);

    const navigationOptions = { pageNavOptions, appUserLinkItems };

    return { navigationOptions, allowItemPopup };
  }, [
    // include everything that influences the computed output
    pageNavOptions,
    appUserAccess,
    aps_appUserSettings,
    itemData ? itemData.id : null,
    itemData, // if other fields are read by getAppUserLinks
    viewKey,
    viewItem,
  ]);

  return result;
};

const getAllowPopup = (pageNavOptions) => {

  let aip = false
  let totalCount = 0

  if (!_.isEmpty(pageNavOptions?.appUserDirect)) {
    aip = true
    totalCount += _.size(pageNavOptions.appUserDirect)
  }

  if (!_.isEmpty(pageNavOptions?.dataManagement)) {
    aip = true
    totalCount += _.size(pageNavOptions.dataManagement)
  }

  if (!_.isEmpty(pageNavOptions?.dataModification)) {
    aip = true
    totalCount += _.size(pageNavOptions.dataModification)
  }

  if (!aip && !_.isEmpty(pageNavOptions)) { aip = true }

  const allowPopup = { allow: aip, count: totalCount }

  return allowPopup
}
